import { render, staticRenderFns } from "./StepMapping.vue?vue&type=template&id=3a47f31d&scoped=true"
import script from "./StepMapping.vue?vue&type=script&lang=js"
export * from "./StepMapping.vue?vue&type=script&lang=js"
import style0 from "./StepMapping.vue?vue&type=style&index=0&id=3a47f31d&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a47f31d",
  null
  
)

export default component.exports